import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const CHAT_AVATAR_URL = `${BASE_URL}/avatar/user/60x60/{username}.jpg`;
